<template>
  <div class="flex gap-4 items-center justify-between md:rounded-xl bg-gray-50 md:border border-neutral-300 px-4 py-2 -mx-4 md:mx-0">
    <div class="hidden md:block text-lg font-semibold">
      Create Your Box
    </div>
    <div class="hidden md:block">
      Showing:
      <span class="text-gray-600">
        {{ $t(`bundler.filters.${store.filter}`) }}
      </span>
    </div>
    <ProductFilterSelect class="grow md:grow-0 min-w-[220px]" />
  </div>
</template>

<script setup lang="ts">
import { useProductsStore } from '@/stores/products'
import ProductFilterSelect from './product-filter-select.vue'
const store = useProductsStore()
</script>
